<template>
    <div class="checkoutpage thankyoupage">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
        <header>
            <div class="container">
                <div class="carthead">
                    <div class="cartlogosec">
                        <a href="/"><b-img class="logo" src="/shop/images/rmcoco_new.webp" alt="Photo camera image"></b-img></a>
                    </div>
                    
                    <router-link class="backcart" to="/shop/products/fabric"><b-img class="backarrow" src="/shop/images/cart.svg" fluid alt="cart image"></b-img> Continue Shopping</router-link>
                </div>
            </div>
        </header>
        <div class="maincart">
            <div class="leftcart">
                <div class="thankyou">
                    <div class="checkmark">
                        <b-img class="check_img" src="/shop/images/check.svg" fluid alt="checkmark image"></b-img>
                    </div>
                    <div class="orderthank">
                        <span>&nbsp;</span>
                        <h1>Thank you for applying!</h1>
                    </div>
                    <h3>&nbsp;</h3>
                    <p>We will review your application and follow up if we have any questions.</p>
                    <hr>
                </div>
            </div>
			<a @click="toggleorder" class="ordershow" href="#">Summary<b-img class="plusfil" src="/shop/images/add.svg" alt="add"></b-img><b-img class="minusfil" src="/shop/images/minus.svg" alt="minus"></b-img></a>
            <div class="rightcart">
                <div class="cartproducts">
                    
                </div>
                 <div class="rightinner">
                      <div class="help_signup mt-0">
                          <p>Need Help?</p>
                          <b-button @click="callusTrigger" variant="outline-primary" squared v-html="callustext"></b-button>
                          <b-button @click="emailusTrigger" variant="outline-primary" squared><b-img src="/shop/images/mail.svg" class="mailblack"></b-img><b-img src="/shop/images/mail-white.svg" class="mailwhite"></b-img>Email Us</b-button>
                      </div>
                  </div>
            </div>
        </div>
        <footer>
            <div class="container">
                <div class="footlink">
                    <ul>
                        <li><router-link to="/terms-of-services/">Terms of Sevices</router-link></li>
                        <li><router-link to="/privacy-policy/">Privacy Policy</router-link></li>
                    </ul>
                    <p class="copyright_text">© 1980 - {{ new Date().getFullYear() }} RM COCO</p>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ResourceMixin from "../mixins/resources";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    components: {
        Loading
    },
    mixins: [ResourceMixin],
    mounted() {
        
    },
    computed: {
        ...mapGetters(["user"])
    },
    data() {
        return {
            orderdetails:[],
            isLoading: false,
            callustext: '<img src="/shop/images/phone.svg" class=""><img src="/shop/images/phone-white.svg" class="whitephone"> Call Us'
        };
    },
	methods:{
	    toggleorder(){
            $(".rightcart").toggle();
            $(".ordershow").toggleClass("minusshow");
		},
		callusTrigger(){
            this.callustext = "800 325 8025";
        },
        emailusTrigger(){
            window.location.href = "mailto:customerservice@rmcoco.com";
        },
	}
};
</script>